import axios from 'axios'
import store from '@/store'

// default our apiUrl for tests
const apiUrl = window.config ? window.config.apiUrl : ''

// axios global requests
axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + store.getters['auth/token']
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// axios global response
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (apiUrl !== '') {
      console.debug(`Error Message from interceptor (${apiUrl}): ${error.message}`, error)
    }
    if (
      error &&
      error.response &&
      error.response.status === 401 &&
      store.getters['auth/token']
    ) {
      store.dispatch('auth/clearToken')
      window.location = '/login'
    }
    return Promise.reject(error)
  }
)

// export axios common base instance (resource: https://goo.gl/sDN0IN)
export default {
  get: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.get(`${host}/${endpoint}`, data, config)
  },
  put: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.put(`${host}/${endpoint}`, data, config)
  },
  post: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.post(`${host}/${endpoint}`, data, config)
  },
  delete: (endpoint, data = {}, config = {}, host = apiUrl) => {
    return axios.delete(`${host}/${endpoint}`, data, config)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/api.js